<template>
    <on-click-outside
        :is-active="isOpen"
        :execute="close"
        :exclude="['.dropdown-menu']"
    >
        <div class="relative flex flex-col w-full m-auto">
            <slot />
        </div>
    </on-click-outside>
</template>

<script>
    export default {
        props: {
            isOpen: {
                type: Boolean,
                required: true
            }
        },
        methods: {
            close () {
                this.$emit('close', false)
            }
        }
    }
</script>
